import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../app/stores/store';
import DatePicker from 'react-datepicker';
import { useEffect, useRef, useState } from 'react';
import { scheduleTabSubTasks } from '../../../../app/api/types';

type Props = {
  taskId: string;
  subTaskDetails: scheduleTabSubTasks;
  getChangedDate: (taskId: string, subTaskId: string, newDate: string) => void;
  editEnabled: boolean;
  isExtend: boolean;
};

function ScheduleDatePicker({
  taskId,
  subTaskDetails,
  getChangedDate,
  editEnabled,
  isExtend,
}: Props) {
  const {
    PivotStore,
    activityStore: { selectedActivity: activity },
  } = useStore();
  const [date, setDate] = useState<string>('');
  const nextDate = useRef<Date>();

  const dateChange = (date: string) => {
    const newDate = PivotStore.dateFormat(date);
    setDate(newDate);
    getChangedDate(taskId, subTaskDetails.subTaskId, newDate);
  };

  useEffect(() => {
    setDate(subTaskDetails.endSTDate);
    //eslint-disable-next-line
  }, [editEnabled]);

  useEffect(() => {
    const currentDate = new Date(subTaskDetails.endSTDate);
    currentDate.setDate(currentDate.getDate() + 1);
    nextDate.current = currentDate;
  }, [subTaskDetails.endSTDate]);

  return (
    <>
      {isExtend ? (
        <DatePicker
          value={
            editEnabled
              ? PivotStore.dateFormat(date)
              : PivotStore.dateFormat(subTaskDetails.endSTDate)
            // new Date().toLocaleDateString()
          }
          showYearDropdown
          dateFormatCalendar="MMMM"
          locale={'en'}
          className="date-picker-style"
          yearDropdownItemNumber={15}
          minDate={nextDate.current}
          scrollableYearDropdown
          onChange={(date: any) => dateChange(date)}
          disabled={!editEnabled || subTaskDetails.status === 2}
          selected={date ? new Date(date) : new Date(subTaskDetails.endSTDate)}
          popperProps={{ strategy: 'fixed' }}
          showMonthDropdown
        />
      ) : (
        <DatePicker
          value={
            editEnabled
              ? PivotStore.dateFormat(date)
              : PivotStore.dateFormat(subTaskDetails.endSTDate)
            // new Date().toLocaleDateString()
          }
          showMonthDropdown
          showYearDropdown
          dateFormatCalendar="MMMM"
          locale={'en'}
          className="date-picker-style"
          yearDropdownItemNumber={15}
          minDate={nextDate.current}
          maxDate={new Date(activity?.projectEndDate || '')}
          scrollableYearDropdown
          onChange={(date: any) => dateChange(date)}
          disabled={!editEnabled || subTaskDetails.status === 2}
          selected={date ? new Date(date) : new Date(subTaskDetails.endSTDate)}
          popperProps={{ strategy: 'fixed' }}
        />
      )}
    </>
  );
}

export default observer(ScheduleDatePicker);
